import Banner from "@/components/landing/homeFive/Banner";
import BuyCrypto from "@/components/landing/homeFive/BuyCrypto";
import BuySell from "@/components/landing/homeFive/BuySell";
import HowItsWork from "@/components/landing/homeFive/HowItsWork";
import AppDownload from "@/components/landing/homeFour/AppDownload";
import Faqs from "@/components/landing/homeThree/Faqs";

export default function HomeFive() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Buy Sell section */}
      <BuySell />

      {/* Buy Crypto section */}
      <BuyCrypto />

      {/* How Its Work section */}
      <HowItsWork />

      {/* App Download section */}
      <AppDownload />

      {/* Faqs section */}
      <Faqs />
    </>
  );
}
